<template>
  <div
    v-if="open && isInternetExplorer()"
    class="ie-popup"
  >
    <div class="ie-popup--toaster">
      <button
        class="ie-popup--toaster__close-button"
        @click="closeModal()"
      >
        <span class="is-sr-only">{{ closeIconAlt }}</span>
      </button>
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
  import { isInternetExplorer } from '@Foundation/utilities/isInternetExplorer';
  export default {
    name: 'IePopup',
    props: {
      closeIconAlt: {
        type: String,
        required: false,
        default: 'Close'
      },
    },
    data() {
      return {
        open: false,
        canOpen: false
      };
    },
    mounted() {
      this.checkIfShouldShow();
      this.showModalIfCookieIsClosed();
    },
    methods: {
      isInternetExplorer,
      showModalIfCookieIsClosed() {
        if (!this.canOpen) {
          return;
        }

        this.openModal();
      },
      openModal() {
        this.open = true;
      },
      closeModal() {
        this.open = false;
        localStorage.setItem('iePopupClosed', true);
      },
      checkIfShouldShow() {
        this.canOpen = localStorage.getItem('iePopupClosed') === null;
      }
    }
  };
</script>
